export default {
  // 主要内容外的其他元素总高度 导航栏+padding+标题+footer高度 54+32+60+70
  mainContentOutsizeH: 216,

  // idata 内嵌页面背景色
  idataBackgroundColor: '#f5f5f7',

};
